"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "attigliano": {
    "94ddb41c": [{
      "hkey": "641de056",
      "slug": "attigliano",
      "name": "Attigliano",
      "primary": true,
      "skipSearch": false
    }],
    "bufalino": [{
      "hkey": "641de056",
      "slug": "attigliano",
      "name": "Attigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "90e4c1f1": [{
      "hkey": "641de056",
      "slug": "attigliano",
      "name": "Attigliano",
      "primary": true,
      "skipSearch": false
    }],
    "la-croce": [{
      "hkey": "641de056",
      "slug": "attigliano",
      "name": "Attigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "72a6a5db": [{
      "hkey": "641de056",
      "slug": "attigliano",
      "name": "Attigliano",
      "primary": true,
      "skipSearch": false
    }],
    "la-stazione": [{
      "hkey": "641de056",
      "slug": "attigliano",
      "name": "Attigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c1cb143d": [{
      "hkey": "641de056",
      "slug": "attigliano",
      "name": "Attigliano",
      "primary": true,
      "skipSearch": false
    }],
    "lo-stradone": [{
      "hkey": "641de056",
      "slug": "attigliano",
      "name": "Attigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "36b123ac": [{
      "hkey": "641de056",
      "slug": "attigliano",
      "name": "Attigliano",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-delle-grazie": [{
      "hkey": "641de056",
      "slug": "attigliano",
      "name": "Attigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d84ec0d1": [{
      "hkey": "641de056",
      "slug": "attigliano",
      "name": "Attigliano",
      "primary": true,
      "skipSearch": false
    }],
    "rioni-la-piazza": [{
      "hkey": "641de056",
      "slug": "attigliano",
      "name": "Attigliano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;